import { Field, Form, Formik } from "formik";
import { Button, Checkbox, FullscreenModal } from "shared";
import { useUpdateOwnerInvestmentRelianceAccess } from "hooks/successors";
import { RELIANCE_CONSENT_LABEL } from "../EditInvestmentModal/forms/constants";

interface EditRelianceAccessModalItem {
  uuid: string;
  relianceCanView?: boolean;
}

interface EditRelianceAccessModalProps {
  isOpen: boolean;
  onClose: () => void;
  item: EditRelianceAccessModalItem | null;
  ownerUuid: string | null;
}

interface EditRelianceAccessFormValues {
  relianceCanView: boolean;
}

const EditRelianceAccessModal = ({
  isOpen,
  onClose,
  item,
  ownerUuid,
}: EditRelianceAccessModalProps) => {
  const { mutate: updateRelianceAccess, isPending } =
    useUpdateOwnerInvestmentRelianceAccess();

  const initialValues: EditRelianceAccessFormValues = {
    relianceCanView: Boolean(item?.relianceCanView ?? false),
  };

  const handleSubmit = (values: EditRelianceAccessFormValues) => {
    if (!item || !ownerUuid) return;
    updateRelianceAccess(
      {
        ownerUuid,
        uuid: item.uuid,
        relianceCanView: values.relianceCanView,
      },
      {
        onSuccess: () => {
          onClose();
        },
      },
    );
  };

  return (
    <FullscreenModal
      className="editInvestment"
      isOpen={isOpen}
      onClose={onClose}
    >
      <>
        <h2 className="fullscreen-modal__header">Edycja dostępu do aktywa</h2>
        <Formik
          initialValues={initialValues}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {(formik) => (
            <Form>
              <div className="modal-form__fields">
                <Field
                  as={Checkbox}
                  name="relianceCanView"
                  label={RELIANCE_CONSENT_LABEL}
                  checked={formik.values.relianceCanView}
                  onChange={() =>
                    formik.setFieldValue(
                      "relianceCanView",
                      !formik.values.relianceCanView,
                    )
                  }
                />
              </div>
              <div className="modal-buttons">
                <Button
                  type="button"
                  className="button--stroke button--rounded"
                  onClick={onClose}
                  label="Anuluj"
                />
                <Button
                  type="submit"
                  className="button--black button--rounded"
                  onClick={() => {}}
                  label={isPending ? "Zapisywanie..." : "Zapisz"}
                  isLoading={isPending}
                />
              </div>
            </Form>
          )}
        </Formik>
      </>
    </FullscreenModal>
  );
};

export default EditRelianceAccessModal;
